import { useStyles } from '../theme';
import {
  Avatar,
  Grid,
  Typography,
  Hidden,
  Accordion,
  AccordionSummary,
  Link
} from '@material-ui/core';
import { useIsFeatureFlagEnabled } from '../contexts/feature-flag-context';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Moment from 'react-moment';

import { GigTable } from './GigTable';

const styles = () => ({
  titlePadding: {
    paddingLeft: 32,
    paddingRight: 32
  },
  adminLink: {
    fontSize: 17,
    color: '#008383',
    textTransform: 'uppercase'
  },
  columnText: {
    fontSize: 15,
    letterSpacing: 0.08,
    fontWeight: 500
  },
  columnEndText: {
    fontSize: 18,
    letterSpacing: 0.15,
    fontWeight: 500
  },
  textDarkGray: {
    color: '#7A7A7A'
  },
  detailsHeader: {
    backgroundColor: '#F7F7F7',
    borderTop: '1px solid #A8A8A8',
    borderBottom: '1px solid #A8A8A8',
    paddingTop: 16,
    paddingBottom: 16
  },
  columnTitle: {
    fontSize: 13
  },
  panelDetails: {
    padding: 0,
    flexDirection: 'column'
  },
  driverText: {
    fontSize: 18,
    letterSpacing: 0.15,
    fontWeight: 500,
    marginLeft: 13 
  },
  driverAvatar: {
    width: 32,
    height: 32
  }
});

const Driver = ({ driver, classes }) => {
  const { name, id } = driver || {};
  const adminDriverDetailsLink = `https://admin.roadie.com/profiles/${id}`;
  return (
    <Link target="_blank" href={adminDriverDetailsLink}>
      <Typography
        variant="body1"
        className={classes.driverText}
        style={{
          color: '#008383'
        }}
      >
        {!!name && name}
      </Typography>
    </Link>
  );
};

const LastEvent = ({ event }) => {
  if (event) {
    return (
      <span>
        <Typography
          variant="body2"
          style={{
            color: '#7A7A7A',
            fontSize: 15,
            fontWeight: 500,
            textWrap: 'nowrap'
          }}
        >
          {event.eventType} (<Moment format="MMM DD">{event.timestamp}</Moment>{' '}
          • <Moment fromNow>{event.timestamp}</Moment>)
        </Typography>
      </span>
    );
  }
  return <span></span>;
};

export const DriverTableRow = ({
  groupedGig,
  expanded,
  setGroupedGigExpandedState,
  showFirstAndLastName,
  textlineGroupUuid,
  boardId,
  bucketId
}) => {
  const classes = useStyles(styles);
  const driverAvatarFlag = useIsFeatureFlagEnabled("vip-fe-driver-avatar");

  const { driver, gigCount, lastEvent } = groupedGig;
  const adminSelfieComparisonLink = `https://admin.roadie.com/profiles/${driver?.id}/selfie_comparisons`;

  const naText = (
    <Typography
      variant="body1"
      className={`${classes.columnText} ${classes.textDarkGray}`}
    >
      N/A
    </Typography>
  );
  return (
    <Accordion
      defaultExpanded={false}
      expanded={expanded}
      square
      elevation={0}
      onChange={setGroupedGigExpandedState}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={`${classes.titlePadding}`}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          wrap="nowrap"
        >
          <Grid container md={3} xs={8} direction="row" alignItems="center">
            <Grid item md="auto" xs="auto">
              <Link
                target="_blank"
                href={adminSelfieComparisonLink}
              >
                {driverAvatarFlag && <Avatar alt={driver?.name} src={driver?.verifiedAvatarUrl} className={classes.driverAvatar} />}
              </Link>
            </Grid>
            <Grid item md="auto" xs="auto">
              {driver ? (
                <Driver driver={driver} classes={classes} />
              ) : (
                <Typography
                  variant="body1"
                  className={classes.driverText}
                >
                  N/A
                </Typography>
              )}
            </Grid>
          </Grid>
          <Hidden smDown>
            <Grid item md={6}>
              {lastEvent ? <LastEvent event={lastEvent} /> : naText}
            </Grid>
          </Hidden>
          <Grid item md={2} xs={4} align="right">
            <Typography variant="body1" className={`${classes.columnEndText}`}>
              {`${gigCount} ${gigCount > 1 || gigCount === 0 ? 'gigs' : 'gig'}`}
            </Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      {expanded && (
        <GigTable
          isNested={true}
          key={`grouped-gig-${driver?.id || 'unassigned'}`}
          classes={classes}
          gigs={groupedGig.gigs}
          boardId={boardId}
          bucketId={bucketId}
          showFirstNameLastName={showFirstAndLastName}
          textlineGroupUuid={textlineGroupUuid}
          headerColorClass={classes.detailsHeader}
        />
      )}
    </Accordion>
  );
};
